// components/seating-chart/SeatingChartSeat.js — v4
//
// Change: `draggable` is now an explicit prop from the parent instead of
// being derived internally from `mode`. This is what lets CanvasStage
// enforce "seats belonging to a row/grid group are never individually
// draggable — only the whole group can move" without this component needing
// to know about row groups at all. Also adds onDoubleClick for the
// drill-into-a-single-seat interaction.

import React from "react";
import { Circle, Group, Text } from "react-konva";

export const SEAT_RADIUS = 14;
const NO_CATEGORY_COLOR = "#666666";

const SeatingChartSeat = ({
  seat,
  isSelected,
  isDimmed = false,
  draggable,
  categoryColor,
  shapeRefs,
  onSelect,
  onDoubleClick,
  onDragEnd,
  onTransformEnd,
}) => {
  const fill = categoryColor ?? NO_CATEGORY_COLOR;

  return (
    <Group
      key={seat.id}
      x={seat.x}
      y={seat.y}
      rotation={seat.rotation}
      opacity={isDimmed ? 0.25 : 1}
      draggable={draggable}
      onClick={(e) => onSelect(e, seat.id)}
      onDblClick={(e) => onDoubleClick?.(e, seat.id)}
      onDragEnd={(e) => onDragEnd(e, seat.id)}
      onTransformEnd={(e) => onTransformEnd(e, seat.id)}
      ref={(node) => {
        if (shapeRefs?.current) shapeRefs.current[seat.id] = node;
      }}
    >
      {isSelected && <Circle radius={SEAT_RADIUS + 4} stroke="#007AFF" strokeWidth={2} />}
      <Circle radius={SEAT_RADIUS} fill={fill} stroke="#1e1e1e" strokeWidth={1} />
      <Text
        text={seat.label}
        fontSize={10}
        fill="white"
        width={SEAT_RADIUS * 2}
        height={SEAT_RADIUS * 2}
        offsetX={SEAT_RADIUS}
        offsetY={SEAT_RADIUS}
        align="center"
        verticalAlign="middle"
        listening={false}
        rotation={-seat.rotation}
      />
    </Group>
  );
};

export default React.memo(SeatingChartSeat);